import React from 'react';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { StyledEarningsHeader } from './index.style';

const EarningsHeader = () => {
  const { t } = useTranslation();
  return (
    <StyledEarningsHeader>
      <CommonButton
        aria-label="close"
        variant="outlineSmall"
        customStyle={{
          width: '40px',
          height: '40px',
          minWidth: '40px',
        }}
        onClick={() => window.history.back()}
      >
        <ArrowBackRoundedIcon
          sx={{ fontSize: '24px', color: COLOR.navyBlue }}
        />
      </CommonButton>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <Typography variant="body-24-bold" color={COLOR.darkGray}>
          {t('metricAndEarn')}
        </Typography>
        <Typography variant="body-16-regular" color={COLOR.descriptionUpload}>
          {t('descHeaderMetricAndEarn')}
        </Typography>
      </div>
    </StyledEarningsHeader>
  );
};

export default EarningsHeader;
